import { getUserCredentials, getLocalOrderTime } from '@mummssoftware/utils/orders';
import { CPF, PRN } from '@mummssoftware/utils/orders/orders-constants';
import { formatLocDateMMDDYYYY } from '@mummssoftware/utils/formatters';
import messages from './messages';
/**
 * Orders statement
 * When isPhysicianRoleGroup: use cpfPhysOrder (physician signs as ordering)
 */

export const getFormattedMsg = (intl, currentUser, ordertype, inProgressCPVFOrder, verbalDate, admitPhysician, convoType, isPhysicianRoleGroup) => {
  const signDate = getLocalOrderTime(currentUser);
  const userTitle = getUserCredentials(currentUser);
  const userCredentials = getUserCredentials(currentUser);

  switch (ordertype) {
    case PRN:
    case CPF:
      {
        const orderChanges = `${Object.values(inProgressCPVFOrder).reduce((seed, cpf) => seed.concat(`${cpf.frequencyMessage}`), '')}`;
        const cpfOrder = isPhysicianRoleGroup ? messages.cpfPhysOrder : messages.cpfOrder; // eslint-disable-next-line no-nested-ternary

        const doctorLabel = isPhysicianRoleGroup ? userCredentials : admitPhysician ? (admitPhysician === null || admitPhysician === void 0 ? void 0 : admitPhysician.fullName) || (admitPhysician === null || admitPhysician === void 0 ? void 0 : admitPhysician.label) // OP-33278: sentence keeps First Last
        : '';
        return intl.formatMessage(cpfOrder, {
          userTitle,
          conversation: convoType === null || convoType === void 0 ? void 0 : convoType.label,
          date: formatLocDateMMDDYYYY(verbalDate),
          doctor: doctorLabel,
          orderChanges,
          userCredentials,
          signDate
        });
      }

    default:
      return '';
  }
};